<template>
  <section>
    <div class="fw-600 text-black-1 text-center fs-24">
      Check Your Email for Confirmation
    </div>
    <div class="text-center mb-4 fs-16 text-black-1 fw-400">
      Please verify your email by clicking the link we’ve sent to <span class="fw-500"> {{ form.email }}</span>
    </div>
    <div class="form-group mb-3">
      <div class="text-dark-grey-1 fw-500 fs-15">Enter code</div>
      <PasswordInput v-model="form.verification_code" />
      <ShrInputError :error="errors.verification_code" />
    </div>
    <div class="form-group my-3">
      <SfeButton @click.prevent="verifyAccount" :disabled="submitting" class="btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 py-3 w-100">
        <span class="d-flex align-items justify-content-center">
          <span>Verify Email</span>
          <SfeLoader size="sm" class="ml-1" color="white" v-if="submitting" />
        </span>
      </SfeButton>
    </div>
    <div :class="[isLandingPage ? 'mb-2' : 'mb-5', 'mt-3 text-center text-muted']">
      Didn't receive any verification email?
      <SfeLoader v-if="sendingVerification" size="sm">Please wait</SfeLoader>
      <a v-else class="text-primary" href="#" @click.prevent="resendVerificationCode"><strong>Resend</strong></a>
    </div>
  </section>
</template>

<script>
import CandidateModel from "../../models/CandidateModel";
import PasswordInput from "./PasswordInput.vue";

export default {
  mixins: [CandidateModel],
  components: {
    PasswordInput
  },
  data(){
    return {
      form: {
        verification_code: '',
        email: this.$store.state.verificationEmail
      },
      submitting: false,
      sendingVerification: false,
      errors: {},
    }
  },
  props: {
    isLandingPage: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    verifyAccount(){
      this.submitting = true
      this.errors = {};
      this.CandidateModel.verifyAccount(this.form).then(r => {
        this.trackEvent('Sign-up completed: OTP verified successfully');
        this.$sfeToast.toast('success', 'Success', r.message)
        this.$emit('verification:successful', r.data)
      }).catch(e => {
        this.trackEvent('Sign-up failed: OTP verfication failed');
        this.errors = e?.errors || {}
      }).finally(() => {
        this.submitting = false
      })
    },

    resendVerificationCode(){
      this.sendingVerification = true
      this.CandidateModel.resendVerificationCode({
        email: this.form.email
      }).then(r => {
        this.trackEvent('Sign-up: OTP request');
        this.$sfeToast.toast('success', 'Success', r.message)
      }).finally(() => this.sendingVerification = false)
    }
  }
}
</script>


<style lang="scss" scoped>
.text-dark-grey-1 {
    color: #454545
}
</style>